<mat-card>
  <mat-card-title>{{ '+USER_DETAILS.ADDRESS_DETAILS.TITLE' | translate }}</mat-card-title>
  <mat-card-content>
    <form [formGroup]="formGroup" class="flex flex-col">
      <div class="flex flex-row lt-sm:flex-wrap gap-[24px] lt-sm:gap-[0px]">
        <mat-form-field
          mat-input-height-large-label
          class="flex-[100%] max-w-[50%] lt-sm:flex-[100%] lt-sm:max-w-[100%]"
          id="street"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.STREET' | translate }}</mat-label>
          <input
            gtm="onTextField"
            gtmId="street"
            gtmAction="Street"
            gtmCategory="userAddressDetails"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            formControlName="street"
            data-at-street-edit
            fieldTextContentTooltip
          />
        </mat-form-field>
        <mat-form-field
          mat-input-height-large-label
          class="flex-[100%] max-w-[50%] lt-sm:flex-[100%] lt-sm:max-w-[100%]"
          id="houseNumber"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.HOUSE_NUMBER' | translate }}</mat-label>
          <input
            gtm="onTextField"
            gtmId="house-number"
            gtmAction="House number"
            gtmCategory="userAddressDetails"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            formControlName="houseNumber"
            data-at-house-number-edit
            fieldTextContentTooltip
          />
        </mat-form-field>
      </div>
      <div class="flex flex-row lt-sm:flex-wrap gap-[24px] lt-sm:gap-[0px]">
        <mat-form-field
          mat-input-height-large-label
          class="flex-[100%] max-w-[50%] lt-sm:max-w-[100%]"
          id="zip"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.ZIP' | translate }}</mat-label>
          <input
            gtm="onTextField"
            gtmId="zip"
            gtmAction="Zip"
            gtmCategory="userAddressDetails"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            formControlName="zip"
            data-at-zip-edit
            fieldTextContentTooltip
          />
          <mat-error *ngIf="formGroup.controls.zip.hasError('required')">
            {{ '+USER_DETAILS.VALIDATION.ZIP.REQUIRED_ERROR' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field
          mat-input-height-large-label
          class="flex-[100%] max-w-[50%] lt-sm:max-w-[100%]"
          id="city"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.CITY' | translate }}</mat-label>
          <input
            gtm="onTextField"
            gtmId="city"
            gtmAction="City"
            gtmCategory="userAddressDetails"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            formControlName="city"
            data-at-city-edit
            fieldTextContentTooltip
          />
          <mat-error *ngIf="formGroup.controls.city.hasError('required')">
            {{ '+USER_DETAILS.VALIDATION.CITY.REQUIRED_ERROR' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div
        class="flex flex-row lt-sm:flex-wrap gap-[24px] lt-sm:gap-[0px]"
        *ngIf="supportedCountries.length > 0"
      >
        <mat-form-field
          mat-select-height-large
          class="flex-[100%] max-w-[50%] lt-sm:max-w-[100%]"
          id="country"
        >
          <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.COUNTRY' | translate }}</mat-label>
          <mat-select formControlName="country" data-at-country-edit fieldTextContentTooltip>
            <mat-option
              *ngFor="let country of supportedCountries"
              [value]="country.countryCode"
              gtm="onSelect"
              gtmAction="Country"
              gtmCategory="userAddressDetails"
              fieldTextContentTooltip
            >
              {{ country.country | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="filler"></div>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center" align="end">
    <button
      id="cancel-btn"
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="userAddressDetails"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      id="save-btn"
      mat-raised-button
      color="primary"
      [disabled]="formGroup.invalid"
      gtm="onSave"
      gtmCategory="userAddressDetails"
      (click)="onSave()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
